import styled from 'styled-components';
import { Colors, MagicBox } from '@brg/ui';
import { FC } from 'react';
import {LayoutConst} from "../../../core";


const ArtzLogoContainer = styled(MagicBox)`
    letter-spacing: -0.02em;
    margin-left: 0px !important;
    color: ${Colors.galBlack100} !important;
    span {
        margin-left: 0px !important;
    }
`;

const ArtzLogoTextWrapper = styled.div<{isFooter?: boolean}>`
    margin-left: ${p => p.isFooter? '0' : '8px'};    
    span {
    font-weight:300;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        margin-left: ${p => p.isFooter? '0' : '0'};
    }
`;


export const Portfolio365Logo:FC = (props:any) => {
    const mainTextLogo = 'portfolio'
    const secondaryTextLogo = '365'

    return <ArtzLogoContainer align='center' onClick={(e) => props.onClick && props.onClick(e)}>
        <ArtzLogoTextWrapper isFooter={props.isFooter}>
            {mainTextLogo}
            <span>{secondaryTextLogo}</span>
        </ArtzLogoTextWrapper>
    </ArtzLogoContainer>
}

import styled from 'styled-components';
import { Colors, MagicBox } from '@brg/ui';
import { FC } from 'react';
import {LayoutConst} from "../../../core";


const ArtzLogoContainer = styled(MagicBox)`
    letter-spacing: -0.02em;
    margin-left: 0px !important;
    color: ${Colors.galBlack100} !important;
    span {
        margin-left: 0px !important;
    }
`;

const ArtzLogoTextWrapper = styled.div<{isFooter?: boolean}>`
    margin-left: ${p => p.isFooter? '0' : '8px'};    
    span {
    font-weight:300;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        margin-left: ${p => p.isFooter? '0' : '0'};
    }
`;


export const Portfolio365Logo:FC = (props:any) => {
    const mainTextLogo = 'portfolio'
    const secondaryTextLogo = '365'

    return <ArtzLogoContainer align='center' onClick={(e) => props.onClick && props.onClick(e)}>
        <ArtzLogoTextWrapper isFooter={props.isFooter}>
            {mainTextLogo}
            <span>{secondaryTextLogo}</span>
        </ArtzLogoTextWrapper>
    </ArtzLogoContainer>
}

